import { createStore, combineReducers } from 'redux'

import user from './reducers/user'
import laudos_status from './reducers/laudos_status'
import laudos_table from './reducers/laudos_table'

const rootReducer = combineReducers({ user, statuses: laudos_status, laudos_table })

export default createStore(rootReducer)